;(function () {
  angular.module('contrast.filters').filter('cut', function () {
    return function (value, wordwise, max, type, tail) {
      if (!value) {
        return ''
      }

      max = parseInt(max, 10)

      if (!max) {
        return value
      }
      if (value.length <= max) {
        return value
      }
      if (!type) {
        type = 'right'
      }

      if (type === 'right') {
        value = value.substr(0, max)
        if (wordwise) {
          var lastSpace = value.lastIndexOf(' ')
          if (lastSpace != -1) {
            value = value.substr(0, lastSpace)
          }
        }
        return value + (tail || '...')
      }
      if (type === 'left') {
        value = value.substr(value.length - (max + 1))
        if (wordwise) {
          var firstSpace = value.IndexOf(' ')
          if (firstSpace != -1) {
            value = value.substr(firstSpace)
          }
        }
        return (tail || '...') + value
      }
      if (type === 'middle') {
        var frontChars = Math.ceil(max / 2)
        var backChars = Math.floor(max / 2)

        return (
          value.substr(0, frontChars) +
          (tail || '...') +
          value.substr(value.length - backChars)
        )
      }
    }
  })
})()
